export const MINIO = process.env.REACT_APP_MINIO;